import Politics from "./components/Politics"
import Footer from "./components/Footer"

function PrivacyPolicyPage(){
    return(
        <>
        <Politics />
        <Footer />
        </>
    )
}

export default PrivacyPolicyPage